import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { padding } from "polished";
import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { Link } from "@brexhq/next/src/components/shared/Link";
import { Text } from "@brexhq/shared/components/Typography/Text";

import { LeadFormSteps } from "../../machines/types";
import { FinalStateViewTemplate } from "../PageTemplates/FinalStateViewTemplate";

export const WaitlistContentContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  flexShrink: 0,
  width: 535,
  textAlign: "center",
  maxWidth: "100%",
  ...padding(0, theme.spacing[32]),
  [theme.breakpoints.phone]: {
    width: "auto",
  },
}));

const Graphics = styled.img(({ theme }) => ({
  marginTop: -150,
  [theme.breakpoints.phone]: {
    marginTop: -50,
  },
}));

export const waitlistGraphic = (
  <Graphics
    alt="waitlist graphic"
    width={"100%"}
    height="auto"
    src={
      "https://brand.brex.com/transform/bb640634-d6e4-4850-bc8d-b07d66316f32/Back-end-Crash_00000"
    }
  />
);

export const Waitlist: React.FC = () => {
  const { colors } = useTheme();

  const waitlistTitle = (
    <Text
      as="h2"
      color={colors.content.primary}
      margin={{
        LRG: [-75, 0, 24, 0],
        MED: [-75, 0, 24, 0],
        SML: [-25, 0, 24, 0],
      }}
      components={{
        LRG: "Headline3",
        MED: "Headline3",
        SML: "Headline4",
      }}
    >
      {
        "Based on your information, Brex might not be the right fit for your business."
      }
    </Text>
  );

  const waitlistCTA = (
    <>
      <Text
        as="p"
        color={colors.content.primary}
        margin={{
          LRG: [0, 0, 24, 0],
          MED: [0, 0, 24, 0],
          SML: [0, 0, 24, 0],
        }}
        components={{
          LRG: "Body2",
          MED: "Body2",
          SML: "Body2",
        }}
      >
        {
          "We want to make sure that every business using Brex has a world class experience. We’re always working on new features to serve growing businesses of all kinds—and we’ll reach out as soon as we have something that better fits yours."
        }
      </Text>
      <Text
        as="p"
        color={colors.content.primary}
        margin={{
          LRG: [0, 0, 8, 0],
          MED: [0, 8, 0, 0],
          SML: [0, 8, 0, 0],
        }}
        components={{
          LRG: "Body2",
          MED: "Body2",
          SML: "Body2",
        }}
      >
        {
          "If you feel like this is a mistake and have additional information for our team to review then please "
        }
        <Link
          modifier="unstyled"
          component={"nav"}
          section="logo"
          to="/signup"
          label="open an account"
          aria-label="Brex logo"
          margin={[0, 0, 0, 0]}
        />
        {"."}
      </Text>
    </>
  );

  return (
    <FinalStateViewTemplate currentLeadFormStep={LeadFormSteps.waitlist}>
      <WaitlistContentContainer>
        {waitlistGraphic}
        {waitlistTitle}
        {waitlistCTA}
      </WaitlistContentContainer>
    </FinalStateViewTemplate>
  );
};
